import { useEffect, useRef } from 'react'

import { useCartStore } from '@/stores/cart-store/cartStore'
import { useStepStore } from '@/stores/step-store/stepStore'

export const useTravelPeriodDependency = () => {
	const { startDate, endDate } = useCartStore.use.travelPeriod()
	const { selectedRooms } = useCartStore.use.roomSelection()
	const removeAllRooms = useCartStore.use.removeAllRooms()
	const resetSteps = useStepStore.use.resetSteps()

	const travelPeriodRef = useRef<{ start: Date | undefined; end: Date | undefined }>({
		start: startDate,
		end: endDate,
	})

	useEffect(() => {
		if (!selectedRooms.length) {
			travelPeriodRef.current = {
				start: startDate,
				end: endDate,
			}
			return
		}

		if (
			startDate !== travelPeriodRef.current.start ||
			endDate !== travelPeriodRef.current.end
		) {
			removeAllRooms()
			resetSteps(['ROOM_SELECTION'])
		}
	}, [startDate, endDate, selectedRooms.length, removeAllRooms, resetSteps])
}
